import { IAddressModel } from '../../address/model/adress.model';
import { IScheduleModel } from './schedule.model';

export interface IBranchModel {
  id: number;
  name: string;
  avatar: string;
  latitude: string;
  longitude: string;
  distance: number;
  address: IAddressModel;
  open: isOpenEnum;
  qualities: qualitiesEnum[];
  schedules: IScheduleModel;
}

export enum isOpenEnum {
  OPEN = 'open',
  CLOSE = 'close',
}

export enum qualitiesEnum {
  WIFI = 'wifi',
  PARKING = 'parking',
  MALL = 'mall',
  RECLUSA = 'reclusa',
  PRIVATE_LIVING_ROOM = 'private_living_room',
}
